import { Card, Col, Container, Row } from "react-bootstrap";
import picture1 from "../../assets/img/rampage/1.png";
import picture2 from "../../assets/img/rampage/2.png";
import picture3 from "../../assets/img/rampage/3.png";
import picture4 from "../../assets/img/rampage/4.png";
import picture5 from "../../assets/img/rampage/5.png";
import picture6 from "../../assets/img/rampage/6.png";
import picture7 from "../../assets/img/rampage/7.png";
import picture8 from "../../assets/img/rampage/8.png";

import Slider from "react-slick";

const QueOfrece = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const datos = [
    {
      title: "Carga y autonomía",
      picture: picture1,
      desc: "Cargá tu Mustang Mach-E usando el cargador de serie para tu hogar o los cargadores públicos CCS2 y aprovechá al máximo su autonomía de 541 km.",
    },
    {
      title: "Diseño",
      picture: picture2,
      desc: "El ADN Mustang con su clásico e imponente diseño, te va a sorprender en cada parte de su interior.",
    },
    {
      title: "Tecnología y conectividad",
      picture: picture3,
      desc: "Tecnología y conectividad intuitiva y funcional. Compatible con Apple Carplay inalámbrico y Android Auto, Sync 4A con pantalla táctil de 15.5'' y carga de celular por inducción.",
    },
    {
      title: "Seguridad",
      picture: picture4,
      desc: "El Mustang Mach-E ofrece lo último en seguridad con tecnologías de última generación.",
    },
    {
      title: "Seguridad",
      picture: picture5,
      desc: "El Mustang Mach-E ofrece lo último en seguridad con tecnologías de última generación.",
    },
    {
      title: "Seguridad",
      picture: picture6,
      desc: "El Mustang Mach-E ofrece lo último en seguridad con tecnologías de última generación.",
    },
    {
      title: "Seguridad",
      picture: picture7,
      desc: "El Mustang Mach-E ofrece lo último en seguridad con tecnologías de última generación.",
    },
    {
      title: "Seguridad",
      picture: picture8,
      desc: "El Mustang Mach-E ofrece lo último en seguridad con tecnologías de última generación.",
    },
  ];
  return (
    <Container fluid style={{ backgroundColor: "#000" }}>
      <Container className="pt-1 pb-5">
        <Row>
          {datos.map((item) => (
            <Col md={3} xs={12} className="p-0 m-0">
              <img src={item.picture} alt="" className="w-100" />
            </Col>
          ))}
        </Row>
      </Container>
    </Container>
  );
};

export default QueOfrece;
